import { Mixpanel } from 'utils/mixpanel'

import { env } from 'env'

import axios from 'axios'
import instance from '../instance'

const API_URL = env.REACT_APP_API_URL

export async function login(email, password) {
	const response = await instance.post('/authentication/login', {
		email,
		password,
	})

	Mixpanel?.identify(response.data.email)

	Mixpanel?.people?.set({
		id: response?.data?.id,
		email: response?.data?.email,
		name: response?.data?.name,
		role: response?.data?.role,
		company: API_URL.replace(/^https:\/\/api-|.digitalk.com.br$/g, '') || '',
	})

	Mixpanel?.track('[ACTION]: Login', {
		EMAIL: response.data.email,
		EMPRESA: API_URL.replace(/^https:\/\/api-|.digitalk.com.br$/g, '') || '',
	})

	return response
}

export function forgot(email) {
	return instance.post('/authentication/forgot_password', { email })
}

export function first_login(
	email,
	old_password,
	new_password,
	new_password_confirmation
) {
	return instance.post('/authentication/first_login', {
		email,
		old_password,
		new_password,
		new_password_confirmation,
	})
}

export function change_password(
	password,
	new_password,
	new_password_confirmation
) {
	return instance.post('/authentication/change_password', {
		password,
		new_password,
		new_password_confirmation,
	})
}

export function auth() {
	return instance.post('/auth')
}

export function verify2faCode(code) {
	const token = localStorage.getItem('token');
	return axios.post(`${env.REACT_APP_API_URL}/api/v1/authentication/login/token/verify`, { code }, {
		headers: {
			Authorization: `Bearer ${token}`
		}
	})
}
